import { render, staticRenderFns } from "./show-details.vue?vue&type=template&id=0ccee0a6&scoped=true&"
import script from "./show-details.vue?vue&type=script&lang=js&"
export * from "./show-details.vue?vue&type=script&lang=js&"
import style0 from "./show-details.vue?vue&type=style&index=0&id=0ccee0a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccee0a6",
  null
  
)

export default component.exports